import React from 'react';
import PropTypes from 'prop-types';

import { icons } from 'src/constants';

import './styles.scss';

// icons list: https://thermoux.s3.amazonaws.com/komodo-icons.css
const Icon = ({ name, size = 16, color = 'black', disabled, className, onClick }) => {
  let iconClassName = `icon-${size}-${name}`;

  if (!name) {
    return null;
  }

  if (color) {
    iconClassName = `${iconClassName} icon-${color}`;
  }

  if (disabled) {
    iconClassName = `${iconClassName} icon-disabled`;
  }

  return (
    <span
      className={`${iconClassName}${className ? ` ${className}` : ''}`}
      onClick={onClick}
    />
  );
};

Icon.propTypes = {
  name: PropTypes.string,
  size: PropTypes.oneOf(icons.ALLOWED_ICON_SIZES),
  color: PropTypes.oneOf(icons.ALLOWED_ICON_COLORS),
  disabled: PropTypes.bool,
  className: PropTypes.string,
  onClick: PropTypes.func,
};

export default Icon;
